import {login, logout, getUserInfo} from "@/api/user";
import {getToken, setToken, removeToken} from "@/utils/auth";

const state = {
    token: getToken(),
    name: localStorage.getItem("ADV_USERNAME") || "",
    avatar: localStorage.getItem("ADV_AVATAR") || "",
    userCode: null,
    status: 0, //0普通用户 1主播 2管理员
    id: null,
    realName: localStorage.getItem("ADV_REAL_NAME") || "",
};

const mutations = {
    SET_TOKEN: (state, token) => {
        state.token = token;
    },
    SET_NAME: (state, name) => {
        state.name = name;
    },
    SET_AVATAR: (state, avatar) => {
        state.avatar = avatar;
    },
    SET_USERCODE: (state, code) => {
        state.userCode = code;
    },
    SET_USER_STATUS: (state, {status, id}) => {
        state.status = status;
        state.id = id;
    },
    SET_REAL_NAME: (state, name) => {
        state.realName = name;
    }
};

const actions = {
    setToken({dispatch, commit}, token) {
        commit("SET_TOKEN", token);
        setToken(token);
        dispatch("getInfo");
    },
    // user login
    login({dispatch, commit}, userInfo) {
        const {mobile, captcha, unionid = ""} = userInfo;
        return new Promise((resolve, reject) => {
            login({mobile: mobile.trim(), captcha: captcha, unionid}).then((response) => {
                const {data} = response;
                commit("SET_TOKEN", data.token);
                setToken(data.token);
                dispatch("getInfo");
                resolve();
            }).catch((error) => {
                reject(error);
            });
        });
    },
    // get user info
    getInfo({commit, state}) {
        return new Promise((resolve, reject) => {
            getUserInfo().then((response) => {
                const {data} = response;
                if (!data) {
                    reject("Verification failed, please Login again.");
                }
                const {username, avatar, user_code, status, id, name} = data;
                commit("SET_NAME", username);
                commit("SET_USERCODE", user_code);
                commit("SET_AVATAR", avatar);
                commit("SET_USER_STATUS", {status, id});
                commit("SET_REAL_NAME", name);
                resolve(data);
            }).catch((error) => {
                reject(error);
            });
        });
    },
    // user logout
    logout({commit, state}) {
        return new Promise((resolve, reject) => {
            commit("SET_TOKEN", "");
            removeToken();
            resolve();
        });
    },

    // remove token
    resetToken({commit}) {
        return new Promise((resolve) => {
            commit("SET_TOKEN", "");
            removeToken();
            resolve();
        });
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
};
